import { createPinia } from 'pinia';
import { computed, createApp } from 'vue';
//@ts-ignore
import App from './App';

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);


import { mapDict } from "src/lib/func";

import { createRouter, createWebHistory, RouteLocationRaw } from 'vue-router';

import useConfigStore from "src/stores/config";

import useRootStore from "@lib/stores/index";
import { setTitle } from "@lib/utils/router";
import authManager from './auth-manager';
import { TabConfig } from "./lib/types/config";
import routes from './routes';



const store = useRootStore();
store.initialize({
    //@ts-ignore
    authManager,
    config: {
        stats: {
            enable: true,
            url: "/stats"
        },
        feedback: {
            enable: false,
        },
    }
});

const router = createRouter({
    routes,
    history: createWebHistory()
});

const push = router.push.bind(router);
router.push = (to: RouteLocationRaw) => {
    console.log(to);
    return push(to);
};

const configStore = useConfigStore();
const tabs = computed<{[tab in string]: TabConfig}>(() => configStore.tabs);

const tabTitles = computed(() => tabs.value ? mapDict(
    tabs.value,
    ({label, fullName = label}: {label: string, fullName?: string}) => fullName
) : {});
const startTab = computed(() => configStore.startTab);

router.beforeEach((to, from) => {
    to.meta = to.meta || {};
    Object.assign(to.meta, {
        tabTitles: tabTitles.value,
        startTab: startTab.value
    });
    console.log(to);


    setTitle(configStore.app.name||"CoreIntegrity", to);
});

configStore.initialize({
    authManager: authManager,
    config: {
        app: {
            apiUrl: "/api/",
            liveUrl: "/live-api",
            display: {
                feedback: false,
                userMenu: true
            },
        },
    }
})
    .then(() => {
        app.use(router as any);        

        return router.isReady();
    })
    .then(() => {
        app.mount('#app');
    });
